export function nonInstitutionEmail() {
    return [
        {name: 'gmail', value: '@gmail'},
        {name: 'yahoo', value: '@yahoo'},
        {name: 'outlook', value: '@outlook'},
        {name: 'hotmail', value: '@hotmail'},
        {name: 'live', value: '@live'},
        {name: 'aol', value: '@aol'},
        {name: 'protonmail', value: '@protonmail'},
        {name: 'tutanota', value: '@tutanota'},
        {name: 'gmx', value: '@gmx'},
        {name: 'zoho', value: '@zoho'},
        {name: 'icloud', value: '@icloud'},
        {name: 'yandex', value: '@yandex'},
        {name: 'msn', value: '@msn'},
        {name: 'mailcom', value: '@mail'},
        {name: 'mailinator', value: '@mailinator'},
        {name: '10minutemail', value: '@10minutemail'},
        {name: 'guerrillamail', value: '@guerrillamail'},
        {name: 'temp-mail', value: '@temp-mail'},
        {name: 'tempmail', value: '@tempmail'},
        {name: 'throwawaymail', value: '@throwawaymail'},
        {name: 'trashmail', value: '@trashmail'},
        {name: 'yopmail', value: '@yopmail'},
        {name: 'disposable-mail', value: '@disposable-mail'},
        {name: 'mail7', value: '@mail7'},
        {name: 'maildrop', value: '@maildrop'},
        {name: 'hushmail', value: '@hushmail'}
    ];
}
 